import React from "react";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {
  Checkbox,
  IconButton,
  makeStyles,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import moment from "moment";

// Custom styles for selected rows and status labels
const useStyles = makeStyles((theme) => ({
  row: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  selectedRow: {
    backgroundColor: "#e6e6e6 !important",
  },
}));

const OrdersTableRow = ({ order, onSelectOrder }) => {
  const classes = useStyles();

  const handleRowClick = () => {
    onSelectOrder(order.id);
  };

  return (
    <TableRow className={`${classes.row}`} onClick={handleRowClick}>
      <TableCell>
        <Typography
          className="px-2 py-1 rounded-full"
          variant="caption"
          style={{
            border: "1px solid #c4c4c4",
            backgroundColor: "#e5e5e5",
            color: "#585656",
          }}
        >
          {order.id}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography
          className="px-2 py-1 rounded-full"
          variant="caption"
          style={{
            border: "1px solid #30b46e",
            backgroundColor: "#a0e2be",
            color: "#04783a",
          }}
        >
          {order.orderNumber}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">
          {order.timeReceived
            ? moment
                .utc(order.timeReceived)
                .local()
                .format("DD/MM/YYYY hh:mm A")
            : " - "}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">
          {order.shippingAddress?.recipientName}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">
          {order.shippingAddress?.fullAddress}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption">{order.orderItems?.length}</Typography>
      </TableCell>
      <TableCell>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {order.courierPackages?.map((p, index) => (
            <Typography
              key={index}
              className="px-2 py-1 rounded-full"
              variant="caption"
              style={{
                border: "1px solid #c4c4c4",
                backgroundColor: "#e5e5e5",
                color: "#585656",
              }}
            >
              {p.packageRepresentation}
            </Typography>
          ))}
        </div>
      </TableCell>
      <TableCell>
        <IconButton size="small">
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default OrdersTableRow;
